import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
const faqs = [{
  question: 'How do I access the guide?',
  answer: 'Immediately after purchase you will receive download links for all three guides.'
}, {
  question: 'Is this beginner friendly?',
  answer: 'Yes. The guide is written for beginners and uses simple ingredients and step-by-step instructions.'
}, {
  question: 'Do I need special equipment?',
  answer: 'No. Most remedies use ingredients and tools commonly found in a kitchen.'
}, {
  question: 'Is this medical advice?',
  answer: 'No. The guide is for educational purposes only and includes safety guidelines. Always consult a healthcare professional for medical concerns.'
}];
export function FAQSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-221">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <div className="flex items-center justify-center gap-3 mb-12" data-id="element-223">
          <HelpCircleIcon className="w-10 h-10 text-emerald-700" data-id="element-224" />
          <h2 className="text-3xl md:text-4xl font-bold text-stone-900" data-id="element-225">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-6" data-id="element-226">
          {faqs.map((faq, index) => <div key={index} className="border border-stone-200 rounded-xl p-6 bg-stone-50" data-id="element-227">
              <h3 className="text-lg font-semibold text-stone-900 mb-2" data-id="element-228">
                {faq.question}
              </h3>
              <p className="text-stone-600 leading-relaxed" data-id="element-229">{faq.answer}</p>
            </div>)}
        </div>
      </div>
    </section>;
}